import {SvgIcon} from './SvgIcon'

export const HistoryIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'currentColor',
  strokeWidth = 1.5,
  classes,
  ariaLabel,
}) => (
  <svg
    aria-hidden={ariaLabel ? undefined : true}
    aria-label={ariaLabel}
    className={classes}
    fill="none"
    focusable="false"
    height={height}
    viewBox="0 0 24 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.2 12a8.8 8.8 0 1 0 8.8-8.8 8.8 8.8 0 0 0-7.4 4M3.2 3.6v3.6h3.6M12 7.6V12l3 1.9"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
    />
  </svg>
)

export const DotsHorizontal: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-dope-gray-1100',
  fillColor = 'none',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor}`}
  >
    <path
      d="M8.5 12C8.5 12.2761 8.27614 12.5 8 12.5C7.72386 12.5 7.5 12.2761 7.5 12C7.5 11.7239 7.72386 11.5 8 11.5C8.27614 11.5 8.5 11.7239 8.5 12Z"
      stroke={strokeColor}
    />
    <path
      d="M12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12Z"
      stroke={strokeColor}
    />
    <path
      d="M16.5 12C16.5 12.2761 16.2761 12.5 16 12.5C15.7239 12.5 15.5 12.2761 15.5 12C15.5 11.7239 15.7239 11.5 16 11.5C16.2761 11.5 16.5 11.7239 16.5 12Z"
      stroke={strokeColor}
    />
  </svg>
)

export const EmojiSad: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'white',
  fillColor = 'none',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.75 4.75H15.25C17.4591 4.75 19.25 6.54086 19.25 8.75V15.25C19.25 17.4591 17.4591 19.25 15.25 19.25H8.75C6.54086 19.25 4.75 17.4591 4.75 15.25V8.75C4.75 6.54086 6.54086 4.75 8.75 4.75Z"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75 15.25C7.75 15.25 9 12.75 12 12.75C15 12.75 16.25 15.25 16.25 15.25"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 10C10.5 10.2761 10.2761 10.5 10 10.5C9.72386 10.5 9.5 10.2761 9.5 10C9.5 9.72386 9.72386 9.5 10 9.5C10.2761 9.5 10.5 9.72386 10.5 10Z"
      stroke={strokeColor}
    />
    <path
      d="M14.5 10C14.5 10.2761 14.2761 10.5 14 10.5C13.7239 10.5 13.5 10.2761 13.5 10C13.5 9.72386 13.7239 9.5 14 9.5C14.2761 9.5 14.5 9.72386 14.5 10Z"
      stroke={strokeColor}
    />
  </svg>
)
